export default __webpack_public_path__ + "static/media/Lixeira.5a9faf4e.svg";